/**
 * API POD pricing + catalogue V4 (bascule Gelato 2026-05-17).
 *
 * Les endpoints cascade (`/pod/catalog/papers|frames|mounts|glazes`) ont
 * été retirés en V4 : Gelato productUid est sémantique opaque, pas de
 * cascade typée. Le wizard `<PrintableSpecModal>` saisit directement le
 * productUid (autocomplete sur `provider_display_name` du cache catalog)
 * + attributes JSON.
 *
 * Routes consommées :
 *   GET    /api/pod/catalog                     → list paginée cache catalog
 *   GET    /api/pod/pricing/config              → lecture marge + fees + tiers
 *   PUT    /api/pod/pricing/config              → mise à jour
 */

import { apiClient } from './client'
import type { components } from '@/types/api-generated'

export type PodSkuCatalogResponse = components['schemas']['PodSkuCatalogResponse']
export type PodSkuCatalogPaginated = components['schemas']['PodSkuCatalogPaginated']
type PodPricingConfigResponse = components['schemas']['PodPricingConfigResponse']
type PodPricingConfigUpdate = components['schemas']['PodPricingConfigUpdate']

export interface ListPodCatalogParams {
  category?: string
  status?: 'active' | 'deprecated' | 'retired'
  page?: number
  page_size?: number
}

export async function listPodCatalogSkus(
  params: ListPodCatalogParams = {},
): Promise<PodSkuCatalogPaginated> {
  const { data } = await apiClient.get<PodSkuCatalogPaginated>('/pod/catalog', { params })
  return data
}

export async function getPodPricingConfig(): Promise<PodPricingConfigResponse> {
  const { data } = await apiClient.get<PodPricingConfigResponse>('/pod/pricing/config')
  return data
}

export async function updatePodPricingConfig(
  payload: PodPricingConfigUpdate,
): Promise<PodPricingConfigResponse> {
  const { data } = await apiClient.put<PodPricingConfigResponse>('/pod/pricing/config', payload)
  return data
}
